/** @format */
import { CourseUnitSelection, OtmId, Plan } from 'common-typescript/types';

export interface CourseUnitVersionChangeSelectionResult {
    plan: Plan;
    /** The CourseUnitSelection mutated in place, or null if none matched oldVersionCourseUnitId. */
    updatedSelection: CourseUnitSelection | null;
    /** substitutedBy ids the selection had before this call cleared them; [] when nothing matched. */
    previousSubstitutedBy: OtmId[];
}

export function updateCourseUnitSelectionForVersionChange(
    oldVersionCourseUnitId: OtmId,
    newVersionCourseUnitId: OtmId,
    plan: Plan,
): CourseUnitVersionChangeSelectionResult {
    const courseUnitSelectionForOldVersion = plan.courseUnitSelections?.find(
        selection => selection.courseUnitId === oldVersionCourseUnitId && !selection.substituteFor?.length,
    );

    if (!courseUnitSelectionForOldVersion) {
        return { plan, updatedSelection: null, previousSubstitutedBy: [] };
    }

    const previousSubstitutedBy = courseUnitSelectionForOldVersion.substitutedBy ?? [];

    courseUnitSelectionForOldVersion.courseUnitId = newVersionCourseUnitId;
    courseUnitSelectionForOldVersion.completionMethodId = null;
    courseUnitSelectionForOldVersion.substitutedBy = [];
    courseUnitSelectionForOldVersion.substituteFor = [];

    plan.assessmentItemSelections = plan.assessmentItemSelections?.filter(selection => selection.courseUnitId !== oldVersionCourseUnitId);

    return { plan, updatedSelection: courseUnitSelectionForOldVersion, previousSubstitutedBy };
}
